<template>
  <div class="section hotGame">
    <div class="h-tt">
      <h2>热门页游</h2>
      <a
        href="javascript:;"
        class="more"
        @click="
          $router.push('/all-game')
          $util.clickStat(`GWSY/RMYY/SYYX`, `官网首页/热门页游/所有游戏`)
        "
      >
        所有游戏
      </a>
    </div>
    <GameList :list="games" :stat-params="statParams" />
  </div>
</template>

<script>
import GameList from '~/components/logic-common/GameList'
export default {
  components: {
    GameList
  },
  data() {
    return {
      games: [],
      statParams: {
        eid: 'GWSY/RMYY/YX',
        eid_desc: '官网首页/热门页游/游戏'
      }
    }
  },
  created() {
    if (process.client) {
      this.$request('hotWebGame').then((data) => (this.games = data))
    }
  },
  methods: {
    getHotClass({ hot_name }) {
      return {
        'min-tab': true,
        'hot-tab': hot_name === 'hot',
        'new-tab': hot_name === 'new'
      }
    }
  }
}
</script>
